import type { History } from "history";
import SessionClient from "../../util/SessionClient";
import StorageClient from "../../util/StorageClient";
import createAirbrake from "./create-airbrake";

const storage = new StorageClient();
const DEV = process.env.NODE_ENV === "development";

type LogToAirbrakeArgs = {
  browserHistory: History;
  session: SessionClient;
  errorUID?: string;
  error: Error;
  info: React.ErrorInfo;
};

export const logToAirbrake = ({ error, browserHistory, session, info, errorUID }: LogToAirbrakeArgs) => {
  const airbrake = createAirbrake();

  if (!airbrake || DEV) return;

  airbrake.notify({
    error,
    params: { info },
    context: {
      userId: session.user?.props.id,
      location: browserHistory.location,
      href: browserHistory.createHref(browserHistory.location),
      session,
      errorUID,
    },
  });

  const chunkError = /Loading chunk \d+ failed/;

  if (chunkError.test(error.message) && !storage.chunkFailed) {
    storage.chunkErrorWithExpiry = true;
    window.location.reload();
  }
};
